
import React from 'react'
import { Link } from 'react-router-dom';
import FarmFeedForm from "../../../../components/Form/Admin/Agriculture/FeedForm";


export default function Add() {
   
   
  return (
    <div className="p-4">
        <div className="flex justify-between items-center py-4 px-6">
            <h1 className="text-lg sm:text-xl md:text-xl lg:text-xl xl:text-2xl font-bold">Feed Add</h1>
            <div>
                <Link to="/admin/agriculture/feed">
                    <button className="px-4 py-2 bg-blue-900 text-white rounded-md mr-4 hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-200">Back</button>
                </Link>
            </div>
        </div>
        <div className="relative overflow-x-auto shadow-md sm:rounded-lg px-4 py-2">
            <FarmFeedForm />
        </div>
    </div>
  )
}
